export default "__VITE_ASSET__Cr19fr75__"